export enum TransactionMethod {
	CASH = "CASH",
	CARD = "CARD",
	TRANSFER = "TRANSFER",
	YAPE = "YAPE",
	PLIN = "PLIN",
}
